const siteConfiguration = {
  dev: {
    colorThemeCode: 0,
    prodDomain: "sfazapp01:65177",
    devDomain: "localhost44351",
    title: "Gustav e-tjänst",
  },
  abf: {
    colorThemeCode: 1,
    prodDomain: "arretjanst.abf.se",
    devDomain: "abfgustav.studieforbunden.se",
    title: "ABF e-tjänst",
  },
  bilda: {
    colorThemeCode: 2,
    prodDomain: "etjanst.bilda.nu",
    devDomain: "bildagustav.studieforbunden.se",
    title: "Bilda e-tjänst",
  },
  folkuniversitetet: {
    colorThemeCode: 3,
    prodDomain: "etjanst.folkuniversitetet.se",
    devDomain: "folkugustav.studieforbunden.se",
    title: "Folkuniversitetet e-tjänst",
  },
  sfr: {
    colorThemeCode: 5,
    prodDomain: "etjanst.studieframjandet.se",
    devDomain: "sfrgustav.studieforbunden.se",
    title: "Studiefrämjandets e-tjänst",
  },
  sv: {
    colorThemeCode: 7,
    prodDomain: "etjanst.sv.se",
    devDomain: "svgustav.studieforbunden.se",
    title: "SV e-tjänst",
  },
  nbv: {
    colorThemeCode: 8,
    prodDomain: "etjanst.nbv.se",
    devDomain: "nbvgustav.studieforbunden.se",
    title: "NBV e-tjänst",
  },
  sensus: {
    colorThemeCode: 11,
    prodDomain: "e-tjanst.sensus.se",
    devDomain: "sensusgustav.studieforbunden.se",
    title: "Sensus e-tjänst",
  },
  kulturens: {
    colorThemeCode: 15,
    prodDomain: "etjanst.kulturens.net",
    devDomain: "kulturensgustav.studieforbunden.se",
    title: "Kulturens e-tjänst",
  },
  mbs: {
    colorThemeCode: 10,
    prodDomain: "etjanst.medborgarskolan.se",
    devDomain: "mbsgustav.studieforbunden.se",
    title: "Medborgarskolan e-tjänst",
  },
  ibnrushd: {
    colorThemeCode: 14,
    prodDomain: "etjanst.ibnrushd.se",
    devDomain: "ibnrushdgustav.studieforbunden.se",
    title: "Ibn rushd e-tjänst",
  },
};
export default siteConfiguration;
